<template>
  <div>
    <TextInputConfiguration
      :controller="WindowStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
  </div>
</template>

<script>
import {inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'

export default {
  name: 'MedianAverage',
  components:{
    TextInputConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      elementsConfig:[],
      WindowStringCtrller: new inputTextConfCtrller(ConfigName.WindowMedianAveragePreProc,'Window','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0})
    }
  },
  mounted(){
    this.elementsConfig = [
      this.WindowStringCtrller
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
}
</script>

<style>
